(function ($, undefined) {
	'use strict';

	let newStr = "";
	let currentLoc;
	let utils;

	const overlays = []; // { id, overlay, type, name }
	let nextNum = 1;
	let pendingEntry = null;
	let map;
	let polygonalCoordinates;
	let activePolygon = null;
	let drawingInProgress = false;

	const domain = window.location.hostname;
	let url = "";
	const personId = $('#geofencePersonId').val();
	const params = new URLSearchParams(window.location.search)

	if (domain === "localhost") {
		url = `http://localhost:9105`;
	} else {
		url = `/geofence-service`;
	}

	const init = () => {
		utils = Fw.component.models().utils;
		$(document).on("click", ".open-modal", toggleModal);
		$(document).on('change', '#location-select', onChangeOfLocationDropdown);
		$(".close-modal").on("click", (e) => {
			const modalFor = $(e.currentTarget).attr("modal-for");
			$("#" + $(e.currentTarget).attr("modal-id")).toggleClass("show-modal");
			if (modalFor == "view-picture" || modalFor == "view-report-img") {
				$(".view-picture").addClass("d-none").removeClass("d-block");
				$(".view-picture").attr("src", "");
				$(".btn-processing").addClass("d-block").removeClass("d-none");

				$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
				$(".view-picture-failed").addClass("d-none").removeClass("d-block");
			}
		});
		$(document).on("click", ".add-user-delete-geofence", (ele) => {
			$(ele.currentTarget).parent().parent().removeClass("add-modify-page-inner-geofence-ctn-location-item").addClass("removed");
		});

		const select = document.getElementById('geofence-select');
		const locationSelect = $('.geofence-location-select');
		if (select) {
			const parent = select.closest('.form-select-ctn');
			if (parent) {
				parent.style.marginTop = '0'; // remove the 20px
			}
		}
		if (locationSelect) {
			locationSelect.css('margin-top', '0');
		}
	};

	function onChangeOfLocationDropdown() {
		let locationId = $('#location-select').val();
		loadLocation(locationId, "", "", true);
	}

	function camelCaseToTitleCase(inputString) {
		// Replace any occurrence of a lowercase letter followed by an uppercase letter
		// with a space and the uppercase letter.
		var result = inputString.replace(/([a-z])([A-Z])/g, '$1 $2');

		// Capitalize the first character of the resulting string.
		result = result.charAt(0).toUpperCase() + result.slice(1);

		return result;
	}

	function initAutocomplete() {
		const input = document.getElementById('geofence-location');

		// Enable Google autocomplete on the input
		const autocomplete = new google.maps.places.Autocomplete(input, {
			types: ['geocode'] // restrict to addresses
		});

		// When user selects an address from suggestions
		// autocomplete.addListener('place_changed', () => {

		// 	const place = autocomplete.getPlace();
		// 	if (place && place.geometry && place.geometry.location) {
		// 		const lat = place.geometry.location.lat();
		// 		const lng = place.geometry.location.lng();
		// 		// const name = place.formatted_address;

		// 		// Create a circle geofence
		// 		const circle = new google.maps.Circle({
		// 			center: { lat, lng },
		// 			radius: 100, // default radius in meters
		// 			fillColor: "#32CD32",
		// 			fillOpacity: 0.3,
		// 			strokeWeight: 2,
		// 			strokeColor: "#32CD32",
		// 			map: map,
		// 			editable: true,
		// 			clickable: true,
		// 			zIndex: 1,
		// 		});

		// 		// Add this geofence to your overlays array
		// 		// const id = "auto_" + Date.now();
		// 		// overlays.push({
		// 		// 	id,
		// 		// 	overlay: circle,
		// 		// 	type: 'circle',
		// 		// 	name
		// 		// });

		// 		// Center map on selected place
		// 		map.setCenter({ lat, lng });

		// 		// Add to dropdown
		// 		// const $select = $('#geofence-select');
		// 		// const option = $('<option>', {
		// 		// 	value: id,
		// 		// 	text: name,
		// 		// 	selected: true
		// 		// });
		// 		// $select.append(option).trigger("change");

		// 		// // Update hidden input or trigger form updates if needed
		// 		// // $('input[name="buildingCoords"]').val(JSON.stringify([`${lat},${lng}`]));

		// 		// // Optional: trigger any logic when geofence added
		// 		// console.log("Auto geofence added:", name, lat, lng);
		// 		// circle.addListener("click", () => removeGeofence(id));


		// 		const id = "internal_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
		// 	const defaultName = `Street ${nextNum}`;
		// 	nextNum++;

		// 	const type = "circle";

		// 	pendingEntry = { id, overlay: circle, type, name: defaultName };

		// 	showNameModal(defaultName, (finalName, confirmed) => {
		// 		if (!confirmed) {
		// 			circle.setMap(null);
		// 			pendingEntry = null;
		// 			return;
		// 		}
		// 		pendingEntry.name = finalName.trim() || defaultName;
		// 		overlays.push(pendingEntry);
		// 		addDropdownOption(pendingEntry);
		// 		printAllGeofences();

		// 		const center = circle.getCenter();
		// 		const radius = circle.getRadius();
		// 		console.log(`${pendingEntry.name} center:`, center.toJSON(), "Radius:", radius);
		// 		alert(`${pendingEntry.name} drawn. Check console for details.`);


		// 		const currentEntry = pendingEntry;
		// 		circle.addListener("click", function () {
		// 			removeGeofence(currentEntry.id);
		// 		});

		// 		pendingEntry = null;
		// 	});

		// 	}
		// });

		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			if (place && place.geometry && place.geometry.location) {
				const lat = place.geometry.location.lat();
				const lng = place.geometry.location.lng();

				// Polygon radius in meters
				const radius = 10; // 10 meters
				const numSides = 6; // hexagon (can change to 4 for square, etc.)

				// Function to compute coordinates around center
				function getPolygonCoords(centerLat, centerLng, radiusMeters, sides) {
					const coords = [];
					const earthRadius = 6378137; // Earth radius in meters
					const angleStep = (2 * Math.PI) / sides;

					for (let i = 0; i < sides; i++) {
						const angle = i * angleStep;
						const dx = radiusMeters * Math.cos(angle);
						const dy = radiusMeters * Math.sin(angle);

						const newLat = centerLat + (dy / earthRadius) * (180 / Math.PI);
						const newLng =
							centerLng + (dx / (earthRadius * Math.cos(centerLat * Math.PI / 180))) * (180 / Math.PI);

						coords.push({ lat: newLat, lng: newLng });
					}
					return coords;
				}

				const polygonCoords = getPolygonCoords(lat, lng, radius, numSides);

				// Create polygon
				const polygon = new google.maps.Polygon({
					paths: polygonCoords,
					strokeColor: "#32CD32",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: "#32CD32",
					fillOpacity: 0.3,
					editable: true,
					map: map,
					zIndex: 1,
				});

				// Center map on selected place
				map.setCenter({ lat, lng });

				const bounds = new google.maps.LatLngBounds();
				polygonCoords.forEach(coord => bounds.extend(new google.maps.LatLng(coord.lat, coord.lng)));
				map.fitBounds(bounds);

				const id = "internal_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
				const defaultName = `Street ${nextNum}`;
				nextNum++;

				const type = "polygon";

				pendingEntry = { id, overlay: polygon, type, name: defaultName, locationName: $('#geofence-location').val() };

				showNameModal(defaultName, (finalName, confirmed) => {
					if (!confirmed) {
						polygon.setMap(null);
						pendingEntry = null;
						return;
					}
					pendingEntry.name = finalName.trim() || defaultName;
					overlays.push(pendingEntry);
					addDropdownOption(pendingEntry);
					printAllGeofences();

					console.log(`${pendingEntry.name} polygon coords:`, polygon.getPath().getArray());

					const currentEntry = pendingEntry;
					polygon.addListener("click", function () {
						removeGeofence(currentEntry.id);
					});

					pendingEntry = null;
				});
			}
		});


		// If user presses ENTER without selecting suggestion
		input.addEventListener('keydown', function (e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				const addr = input.value;
				if (addr) {

					let coords = $("input[name='buildingCoords']");
					let markers = coords.val() == "\"\"" || coords.val() === "" || coords.val() == "" ? "" :
						JSON.parse(coords.val()).map(v => {
							return { lat: parseFloat(v.split(",")[0]), lng: parseFloat(v.split(",")[1]) };
						});

					loadCoordinates(addr, addr, markers, coords, 3, false);
				}
			}
		});
	}

	function getLocations() {

		$.ajax({
			url: `${url}/public/get-locations`,
			method: "get",
			data: {
				personId: personId
			},
			dataType: 'json',
			success: function (response) {
				let content = response.content;
				let entry;
				let buildingName;
				let locId;
				clearAllLocations();
				content.forEach(loc => {

					locId = loc.id;
					buildingName = loc.name;
					entry = { id: loc.id, name: loc.name };
					addDropdownOptionForLocation(entry);

				});
				const modalType = "edit";
				const buildingNameSize = 50;
				$("input[name='locationName']").val(buildingName.substring(0, buildingNameSize) + (buildingName.length <= buildingNameSize ? "" : "..."));
				$("input[name='actionName']").val(modalType);

				// $("input[name='buildingId']").val(modalType == 'edit' ? $(e.currentTarget).parent().parent().attr("id") : "");
				// $("input[name='buildingName']").val(modalType == 'edit' ? $(e.currentTarget).parent().siblings("div").find(".first").html() : "");
				// $("input[name='buildingCoords']").val(modalType == 'edit' ? $(e.currentTarget).parent().parent().attr("geofence-data") : "");

				// let coords = $("input[name='buildingCoords']");
				// let markers = coords.val() == "\"\"" || coords.val() === "" || coords.val() == "" ? "" :
				// 	JSON.parse(coords.val()).map(v => {
				// 		return { lat: parseFloat(v.split(",")[0]), lng: parseFloat(v.split(",")[1]) };
				// 	});

				// if (coords.val() == "") {
				loadLocation(locId, "", "", true);
				// } else {
				// 	currentLoc = { latitude: markers[0].lat, longitude: markers[0].lng };
				// 	loadMaps(markers, coords, false);
				// }

			},
			error: () => {
				console.warn("no data available!");
			}
		});
	}

	// Call this **when your modal opens**
	// (because if you call it when modal is hidden, Google will miscalculate dropdown position)


	async function loadImage(imgUrl) {
		if (imgUrl.includes("&t=")) {
			const res = await fetch(imgUrl.contains("action/getSecureFiles") ? imgUrl : "/action/getSecureFiles?id=" + imgUrl);
			const buff = await res.blob();

			if (buff.type.startsWith('image/') > 0) {
				$(".view-picture").attr("src", URL.createObjectURL(buff));

				$(".view-picture").addClass("d-block").removeClass("d-none");
				$(".view-picture-loader").addClass("d-none").removeClass("d-flex");
			} else {
				$(".view-picture").addClass("d-none").removeClass("d-block");
				$(".btn-processing").addClass("d-none").removeClass("d-block");

				$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
				$(".view-picture-failed").addClass("d-block").removeClass("d-none");
			}
		} else {
			$(".view-picture").addClass("d-none").removeClass("d-block");
			$(".btn-processing").addClass("d-none").removeClass("d-block");

			$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
			$(".view-picture-failed").addClass("d-block").removeClass("d-none");
		}
	}

	async function toggleModal(e) {
		if (window.location.pathname === '/users/add') {
			initAutocomplete();
			getLocations();
		}

		const modal = $("#" + $(e.currentTarget).attr("modal-id"));
		const modalType = $(e.currentTarget).attr("modal-type");
		const modalFor = $(e.currentTarget).attr("modal-for");
		const dataId = $(e.currentTarget).attr("data-id");
		const boxId = $(e.currentTarget).attr("data-str-box-id");
		modal.toggleClass("show-modal");

		if (modalFor == "view-picture") {
			var parent = $(e.currentTarget).parent().parent();
			var json = JSON.parse(parent.attr("data-json"));
			modal.find(".modal-title").text(json.filename);
			if (parent.find(".upload-input__input").length == 0) {
				if (json.id.includes("&t=")) {
					const res = await fetch("/action/sbHandleFile?id=" + json.id);
					const buff = await res.blob();

					if (buff.type.startsWith('image/') > 0) {
						$(".view-picture").attr("src", URL.createObjectURL(buff));

						$(".view-picture").addClass("d-block").removeClass("d-none");
						$(".view-picture-loader").addClass("d-none").removeClass("d-flex");
					} else {
						$(".view-picture").addClass("d-none").removeClass("d-block");
						$(".btn-processing").addClass("d-none").removeClass("d-block");

						$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
						$(".view-picture-failed").addClass("d-block").removeClass("d-none");
					}
				} else {
					$(".view-picture").addClass("d-none").removeClass("d-block");
					$(".btn-processing").addClass("d-none").removeClass("d-block");

					$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
					$(".view-picture-failed").addClass("d-block").removeClass("d-none");
				}
			} else if (parent.find(".upload-input__input").length > 0) {
				const [file] = parent.find(".upload-input__input")[0].files;
				if (file) {
					$(".view-picture").attr("src", URL.createObjectURL(file));

					$(".view-picture").addClass("d-block").removeClass("d-none");
					$(".view-picture-loader").addClass("d-none").removeClass("d-flex");
				} else {
					$(".view-picture").addClass("d-none").removeClass("d-block");
					$(".btn-processing").addClass("d-none").removeClass("d-block");

					$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
					$(".view-picture-failed").addClass("d-block").removeClass("d-none");
				}
			} else {
				$(".view-picture").addClass("d-none").removeClass("d-block");
				$(".btn-processing").addClass("d-none").removeClass("d-block");

				$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
				$(".view-picture-failed").addClass("d-block").removeClass("d-none");
			}
		} else if (modalFor == "dropdown") {
			$("#saveResponseOptBtn").attr("data-id", dataId);
			$("#saveResponseOptBtn").html(modalType == "add" ? "Add" : "Update");

			if (modalType == "add") {
				modal.find(".modal-title").text("Add");
				$("input[name='dropdownOption']").val("");
			} else if (modalType == "edit") {
				modal.find(".modal-title").text("Update");
				$("#saveResponseOptBtn").attr("data-str-box-id", boxId);
				$("input[name='dropdownOption']").val($("." + boxId).html());
			}
		} else if (modalFor == "pictures") {
			$(".save-picture-btn").attr("data-id", dataId);
			var filename = $("#add-picture-name-input");
			var fileInput = $('input[name="resources"]');
			var uploadContainer = $(".upload-input__container");

			$(".save-picture-btn").attr("modal-type", modalType);
			$(".save-picture-btn").attr("data-str-box-id", boxId);

			if (modalType == "add") {
				filename.val("");
				fileInput.val("");
				uploadContainer.find(".upload-input__input").remove();

				uploadContainer.prepend('<input type="file" class="upload-input__input" accept="image/png, image/gif, image/jpeg"></input>');
				$(".upload-input__input").trigger('change');
				$(".upload-input").removeClass('upload-input_completed');
			} else if ((modalType == "edit")) {
				var divInputClone = '<input type="file" class="upload-input__input" accept="image/png, image/gif, image/jpeg"></input>';
				var ppp = $("." + boxId).parent().parent();
				if (ppp.hasClass("_edited")) {
					divInputClone = ppp.find("input").clone();
				}

				uploadContainer.find(".upload-input__input").remove();
				uploadContainer.prepend(divInputClone);
				$(".upload-input__input").trigger('change');
				$(".upload-input").addClass('upload-input_completed');
				if (!(ppp.hasClass("_edited"))) {
					var j = JSON.parse(ppp.attr("data-json"));
					if (j) modal.find(".upload-input__placeholder").text(j.filename);
				}

				filename.val($("." + boxId).html());
			}
		} else if (modalFor == "view-report-img") {
			const modalData = $(e.currentTarget).attr("modal-data");
			const modalData2 = $(e.currentTarget).attr("modal-data2");
			modal.find(".modal-title").text(modalData2);
			const res = await fetch(modalData);
			const buff = await res.blob();

			if (buff.type.startsWith('image/') > 0) {
				$(".view-picture").attr("src", URL.createObjectURL(buff));

				$(".view-picture").addClass("d-block").removeClass("d-none");
				$(".view-picture-loader").addClass("d-none").removeClass("d-flex");
			} else {
				$(".view-picture").addClass("d-none").removeClass("d-block");
				$(".btn-processing").addClass("d-none").removeClass("d-block");

				$(".view-picture-loader").addClass("d-flex").removeClass("d-none");
				$(".view-picture-failed").addClass("d-block").removeClass("d-none");
			}
		} else if (modalFor == "general-history") {
			var modalData = $(e.currentTarget).attr("modal-data");
			var modalData2 = $(e.currentTarget).attr("modal-data2");
			var modalData3 = $(e.currentTarget).attr("modal-data3");
			var historyType = String(modalData3).toLowerCase();
			$("#history-modal .sb-history-modal__header").css("background-color", "#2f7d32");
			var dataBody = $(".dataBody");
			dataBody.html("");

			var escapeHtml = function (value) {
				if (value === null || value === undefined) return "";
				return String(value)
					.replace(/&/g, "&amp;")
					.replace(/</g, "&lt;")
					.replace(/>/g, "&gt;")
					.replace(/\"/g, "&quot;")
					.replace(/'/g, "&#39;");
			};

			var getSummaryHistoryLabel = function () {
				switch (historyType) {
					case "location":
						return "Location";
					case "person":
						return "User";
					case "checklist":
						return "Checklist";
					default:
						return modalData3;
				}
			};

			var getAddedHistoryLabel = function () {
				switch (historyType) {
					case "location":
						return "New Location Added";
					case "person":
						return "New User Added";
					case "checklist":
						return "New Checklist Added";
					default:
						return "Added";
				}
			};

			var allowedLocationFields = {
				field2: true,
				field3: true,
				field4: true,
				field5: true,
				field6: true,
				field7: true,
				field8: true,
				field9: true,
				field10: true,
				field11: true,
				field12: true,
				field13: true,
				field14: true,
				field15: true,
				field16: true,
				field19: true,
				dateField1: true,
				datefield1: true
			};

			var allowedChecklistFields = {
				field2: true,
				field3: true,
				field5: true,
				field6: true,
				field7: true,
				field8: true,
				field9: true,
				field10: true,
				field11: true,
				field12: true,
				field13: true,
				field14: true,
				field16: true,
				field17: true,
				field18: true,
				field19: true,
				field20: true,
				dateField1: true,
				datefield1: true
			};

			var isAllowedHistoryField = function (fieldKey) {
				if (historyType === "location") {
					return !!allowedLocationFields[fieldKey];
				}
				if (historyType === "checklist") {
					return !!allowedChecklistFields[fieldKey];
				}

				return true;
			};

			var getFieldLabel = function (fieldKey) {
				var genericFieldLabels = {
					field2: getSummaryHistoryLabel() + " Name",
					field3: historyType === "location" ? "Information" : "Location",
					field4: historyType === "location" ? "Street Number" : historyType === "checklist" ? "Additional Info" : "Field 4",
					field5: historyType === "location" ? "Street Name" : historyType === "checklist" ? "Button" : "Active",
					field6: historyType === "location" ? "City" : historyType === "checklist" ? "Generic" : "Type",
					field7: historyType === "location" ? "Province" : historyType === "checklist" ? "Active" : "Field 7",
					field8: historyType === "location" ? "Postal Code" : historyType === "checklist" ? "Questions" : "Parent",
					field9: historyType === "location" ? "Country" : historyType === "checklist" ? "Reminder Recurrence" : "Field 9",
					field10: historyType === "location" ? "Assigned Users" : historyType === "checklist" ? "Reminder Value" : "Country",
					field11: historyType === "location" ? "Contacts" : historyType === "checklist" ? "Deficiency Reminder Recurrence" : "State / Province",
					field12: historyType === "location" ? "Validated" : historyType === "checklist" ? "Deficiency Reminder Value" : "Field 12",
					field13: historyType === "location" ? "Completed" : historyType === "checklist" ? "Reminder Emails" : "Field 13",
					field14: historyType === "location" ? "Building Overview" : historyType === "checklist" ? "Old Checklist" : "Field 14",
					field15: historyType === "location" ? "Site Plans" : historyType === "checklist" ? "Tokens" : "Field 15",
					field16: historyType === "location" ? "Documents" : historyType === "checklist" ? "Reminder Start Dates" : "Field 16",
					field17: historyType === "location" ? "QR Code" : historyType === "checklist" ? "Reminder Every X Recurrence" : "Field 17",
					field18: historyType === "location" ? "Emergency Access" : historyType === "checklist" ? "Deficiency Reminder Start Dates" : "Field 18",
					field19: historyType === "location" ? "Activated" : historyType === "checklist" ? "Deficiency Reminder End Dates" : "Field 19",
					field20: historyType === "location" ? "Image" : historyType === "checklist" ? "Deficiency Reminder Emails" : "Field 20",
					field31: "Security Button",
					dateField1: historyType === "location" ? "Created Date" : historyType === "checklist" ? "Last Response Date" : "Date"
				};

				var personFieldLabels = {
					firstName: "First Name",
					lastName: "Last Name",
					email: "Email",
					phone: "Phone",
					mobilePhone: "Mobile Phone",
					activeStatus: "Status",
					company: "Company",
					jobTitle: "Job Title",
					language: "Language",
					addInfo1: "Role",
					addInfo2: "Terms and Conditions",
					addInfo3: "Main Location",
					addInfo4: "Additional Locations",
					addInfo5: "Demo Activated",
					addInfo6: "Created By",
					addInfo7: "Accessible Pages",
					addInfo10: "Account Status"
				};

				if (historyType === "person" && personFieldLabels[fieldKey]) {
					return personFieldLabels[fieldKey];
				}

				if ((historyType === "location" || historyType === "checklist") && genericFieldLabels[fieldKey]) {
					return genericFieldLabels[fieldKey];
				}

				return camelCaseToTitleCase(fieldKey);
			};

			var getComparableValue = function (value) {
				if (value === null || value === undefined) return "";
				if (typeof value === "object") return JSON.stringify(value);
				return String(value);
			};

			var parseNestedJson = function (value) {
				if (value === null || value === undefined) return null;
				if (typeof value === "object") return value;
				if (typeof value !== "string") return null;
				try {
					return JSON.parse(value);
				} catch (error) {
					return null;
				}
			};

			var htmlToText = function (value) {
				if (value === null || value === undefined) return "";
				return $("<div></div>").html(String(value)).text().replace(/\s+/g, " ").trim();
			};

			var formatLongDate = function (value) {
				var date = new Date(value);
				if (isNaN(date.getTime())) {
					return String(value || "");
				}
				return new Intl.DateTimeFormat('en-US', {
					day: '2-digit',
					month: 'short',
					year: 'numeric'
				}).format(date);
			};

			var formatHistoryTimestamp = function (value) {
				var date = new Date(value);
				if (isNaN(date.getTime())) {
					return String(value || "");
				}
				return new Intl.DateTimeFormat('en-US', {
					month: 'short',
					day: '2-digit',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: false
				}).format(date);
			};

			var joinNonEmpty = function (parts) {
				var filtered = [];
				for (var i = 0; i < parts.length; i++) {
					if (parts[i]) {
						filtered.push(parts[i]);
					}
				}
				return filtered.join(', ');
			};

			var formatLocationListBlock = function (entries) {
				var lines = [];
				for (var i = 0; i < entries.length; i++) {
					if (entries[i]) {
						lines.push(entries[i]);
					}
				}
				return lines.join(' | ');
			};

			var getBooleanText = function (value) {
				return String(value) === "true" || value === true ? "Yes" : "No";
			};

			var capitalizeFirst = function (value) {
				var text = String(value || "");
				if (!text) return "";
				return text.charAt(0).toUpperCase() + text.substring(1);
			};

			var normalizeReferenceId = function (value) {
				var text = $.trim(String(value || ""));
				if (!text) return "";
				if (text.indexOf(':') > -1) {
					text = text.split(':')[0];
				}
				return $.trim(text);
			};

			var getResponseTypeText = function (value) {
				if (value === "text") return "Text response";
				if (value === "confirm") return "Confirm response";
				if (value === "yes-no") return "Yes/No response";
				if (value === "dropdown") return "Dropdown Response";
				return capitalizeFirst(value);
			};

			var formatChecklistQuestion = function (question, referenceData) {
				var nfcTagNames = [];
				var tagIds = question.NFCTag ? String(question.NFCTag).split(',') : [];
				for (var tagIndex = 0; tagIndex < tagIds.length; tagIndex++) {
					var tagId = $.trim(tagIds[tagIndex]);
					if (!tagId) continue;
					var nfcLabel = referenceData.nfcTags[tagId] || ("NFC Tag " + tagId);
					var nfcCode = referenceData.nfcTagCodes && referenceData.nfcTagCodes[tagId] ? referenceData.nfcTagCodes[tagId] : "";
					nfcTagNames.push(nfcCode ? (nfcLabel + " (" + nfcCode + ")") : nfcLabel);
				}

				return {
					html: true,
					content:
						'<div class="sb-history-checklist-question" style="background:#ffffff; border:1px solid #dbe8dc; border-radius:8px; padding:12px 14px; margin:8px 0 10px 0;">' +
							'<p style="margin:0 0 8px 0;"><strong>' + escapeHtml(question.name || 'Question') + '</strong></p>' +
							'<p style="margin:0 0 6px 0;"><span style="display:inline-block; width:150px; color:#5f6f63;">Question description:</span><span>' + escapeHtml(question.description || '') + '</span></p>' +
							'<p style="margin:0 0 6px 0;"><span style="display:inline-block; width:150px; color:#5f6f63;">Response type:</span><span>' + escapeHtml(getResponseTypeText(question.responseType)) + '</span></p>' +
							'<p style="margin:0 0 6px 0;"><span style="display:inline-block; width:150px; color:#5f6f63;"></span><span>' + (question.pictureOption ? 'Active picture Option' : '') + '</span></p>' +
							'<p style="margin:0 0 6px 0;"><span style="display:inline-block; width:150px; color:#5f6f63;">NFC validation:</span><span>' + escapeHtml(getBooleanText(question.NFCValidation)) + '</span></p>' +
							'<p style="margin:0;"><span style="display:inline-block; width:150px; color:#5f6f63;"></span><span>' + escapeHtml(nfcTagNames.join(', ')) + '</span></p>' +
						'</div>'
				};
			};

			var formatChecklistQuestionCards = function (value, referenceData) {
				var parsedValue = parseNestedJson(value);
				var list = parsedValue && parsedValue.questions ? parsedValue.questions : [];
				var cards = [];
				for (var questionIndex = 0; questionIndex < list.length; questionIndex++) {
					cards.push(formatChecklistQuestion(list[questionIndex], referenceData));
				}
				return cards;
			};

			var formatReminderTypes = function (value) {
				if (!value) return "empty";
				var types = String(value).split('::');
				var labels = [];
				for (var typeIndex = 0; typeIndex < types.length; typeIndex++) {
					if ($.trim(types[typeIndex])) {
						labels.push(capitalizeFirst($.trim(types[typeIndex])));
					}
				}
				return labels.length > 0 ? labels.join(', ') : "empty";
			};

			var formatReminderValues = function (typesValue, valuesValue, startDatesValue, repetitionsValue) {
				if (!valuesValue) return "empty";
				var types = String(typesValue || "").split('::');
				var values = String(valuesValue || "").split('::');
				var startDates = String(startDatesValue || "").split('::');
				var repetitions = String(repetitionsValue || "").split('::');
				var lines = [];

				for (var reminderIndex = 0; reminderIndex < values.length; reminderIndex++) {
					var recurrence = $.trim(types[reminderIndex] || "");
					var reminderValue = $.trim(values[reminderIndex] || "");
					var startDate = $.trim(startDates[reminderIndex] || "");
					var repetition = $.trim(repetitions[reminderIndex] || "");
					if (!recurrence && !reminderValue && !startDate && !repetition) {
						continue;
					}

					lines.push(joinNonEmpty([
						recurrence ? capitalizeFirst(recurrence) : "",
						reminderValue ? ("Value: " + reminderValue) : "",
						startDate ? ("Start Date: " + formatLongDate(startDate)) : "",
						repetition ? ("Every: " + repetition) : ""
					]));
				}

				return formatLocationListBlock(lines);
			};

			var formatReminderContacts = function (typesValue, contactsValue) {
				var parsedValue = parseNestedJson(contactsValue);
				var contacts = parsedValue && parsedValue.contacts ? parsedValue.contacts : [];
				var types = String(typesValue || "").split('::');
				var groups = [];

				for (var groupIndex = 0; groupIndex < contacts.length; groupIndex++) {
					var recurrence = $.trim(types[groupIndex] || "");
					var contactGroup = contacts[groupIndex] || [];
					var groupLines = [];
					for (var contactIndex = 0; contactIndex < contactGroup.length; contactIndex++) {
						groupLines.push(joinNonEmpty([contactGroup[contactIndex].name, contactGroup[contactIndex].email]));
					}
					if (groupLines.length > 0) {
						groups.push(joinNonEmpty([recurrence ? capitalizeFirst(recurrence) : "", groupLines.join(', ')]));
					}
				}

				return groups.length > 0 ? formatLocationListBlock(groups) : "empty";
			};

			var getPersonRoleText = function (value) {
				var roleMap = {
					"0": "Admin",
					"1": "Manager",
					"2": "Emergency Team",
					"3": "User",
					"4": "Resident",
					"5": "Guest"
				};
				return roleMap[String(value)] || String(value || "empty");
			};

			var formatPersonAccessValue = function (value, referenceData) {
				var parsedValue = parseNestedJson(value);
				if (!parsedValue) {
					return value === null || value === undefined || value === "" ? "empty" : String(value);
				}

				var lines = [];
				for (var locationId in parsedValue) {
					if (!Object.prototype.hasOwnProperty.call(parsedValue, locationId)) {
						continue;
					}

					var access = parsedValue[locationId] || {};
					var normalizedLocationId = normalizeReferenceId(locationId);
					var locationName = referenceData.locations[normalizedLocationId] || "";
					var accessParts = [];

					if (access.all === true || access.all === 'true' || ((access.allProperty === true || access.allProperty === 'true') && (access.allSecurity === true || access.allSecurity === 'true'))) {
						accessParts.push("All property and security buttons");
					} else {
						if (access.allProperty === true || access.allProperty === 'true') {
							accessParts.push("All property buttons");
						}
						if (access.allSecurity === true || access.allSecurity === 'true') {
							accessParts.push("All security buttons");
						}

						var buttonIds = access.ids ? String(access.ids).split(',') : [];
						var buttonNames = [];
						for (var buttonIndex = 0; buttonIndex < buttonIds.length; buttonIndex++) {
							var buttonId = normalizeReferenceId(buttonIds[buttonIndex]);
							if (!buttonId) continue;
							if (referenceData.buttons[buttonId]) {
								buttonNames.push(referenceData.buttons[buttonId]);
							}
						}
						if (buttonNames.length > 0) {
							accessParts.push(buttonNames.join(', '));
						}
					}

					if (!locationName) {
						continue;
					}

					lines.push(locationName + (accessParts.length > 0 ? (" (" + accessParts.join(' | ') + ")") : ""));
				}

				return lines.length > 0 ? lines.join(' | ') : "empty";
			};

			var formatPersonFieldValue = function (fieldKey, value, referenceData) {
				if (value === null || value === undefined || value === "") {
					return "empty";
				}

				switch (fieldKey) {
					case "addInfo1":
						return getPersonRoleText(value);
					case "addInfo2":
					case "addInfo5":
						return getBooleanText(value);
					case "addInfo3":
						var mainLocationId = normalizeReferenceId(value);
						return referenceData.locations[mainLocationId] || "empty";
					case "addInfo4":
						var locationIds = String(value).split(',');
						var locationNames = [];
						for (var locationIndex = 0; locationIndex < locationIds.length; locationIndex++) {
							var locationId = normalizeReferenceId(locationIds[locationIndex]);
							if (!locationId) continue;
							if (referenceData.locations[locationId]) {
								locationNames.push(referenceData.locations[locationId]);
							}
						}
						return locationNames.length > 0 ? locationNames.join(', ') : "empty";
					case "addInfo6":
						var creatorId = normalizeReferenceId(value);
						return referenceData.personNames[creatorId] || ("Person " + creatorId);
					case "addInfo7":
						return formatPersonAccessValue(value, referenceData);
					case "addInfo10":
						return String(value) === 'inactive' ? 'Inactive' : String(value) === 'account-validated' ? 'Account Validated' : String(value);
					default:
						return String(value);
				}
			};

			var getRoleText = function (contact) {
				if (contact.roleText) return contact.roleText;
				if (contact.role === 0 || contact.role === "0") return "To Be Defined";
				return contact.role || "";
			};

			var formatLocationFieldValue = function (fieldKey, value, personNamesMap) {
				var parsedValue;
				var list;
				var lines;

				if (value === null || value === undefined || value === "") {
					return "empty";
				}

				switch (fieldKey) {
					case "field3":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.information ? parsedValue.information : ($.isArray(parsedValue) ? parsedValue : []);
						lines = [];
						for (var infoIndex = 0; infoIndex < list.length; infoIndex++) {
							lines.push(joinNonEmpty([list[infoIndex].title, htmlToText(list[infoIndex].description)]));
						}
						return formatLocationListBlock(lines);
					case "field10":
						list = String(value).split(',');
						lines = [];
						for (var personIndex = 0; personIndex < list.length; personIndex++) {
							var personId = $.trim(list[personIndex]);
							if (!personId) continue;
							lines.push(personNamesMap && personNamesMap[personId] ? personNamesMap[personId] : "Person " + personId);
						}
						return lines.join(', ');
					case "field11":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.contacts ? parsedValue.contacts : ($.isArray(parsedValue) ? parsedValue : []);
						lines = [];
						for (var contactIndex = 0; contactIndex < list.length; contactIndex++) {
							lines.push(joinNonEmpty([
								joinNonEmpty([list[contactIndex].firstName, list[contactIndex].lastName]),
								list[contactIndex].company,
								getRoleText(list[contactIndex]),
								list[contactIndex].phone,
								list[contactIndex].email
							]));
						}
						return formatLocationListBlock(lines);
					case "field12":
						return String(value) === "true" || value === true ? "Validated" : "Not Validated";
					case "field13":
						return String(value) === "true" || value === true ? "Completed" : "Not Completed";
					case "field14":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.overview ? parsedValue.overview : ($.isArray(parsedValue) ? parsedValue : []);
						lines = [];
						for (var overviewIndex = 0; overviewIndex < list.length; overviewIndex++) {
							lines.push(joinNonEmpty([list[overviewIndex].title, htmlToText(list[overviewIndex].description)]));
						}
						return formatLocationListBlock(lines);
					case "field15":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.sitePlan ? parsedValue.sitePlan : ($.isArray(parsedValue) ? parsedValue : []);
						lines = [];
						for (var planIndex = 0; planIndex < list.length; planIndex++) {
							lines.push(joinNonEmpty([list[planIndex].title, list[planIndex].filename]));
						}
						return formatLocationListBlock(lines);
					case "field16":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.document ? parsedValue.document : ($.isArray(parsedValue) ? parsedValue : []);
						lines = [];
						for (var documentIndex = 0; documentIndex < list.length; documentIndex++) {
							lines.push(joinNonEmpty([list[documentIndex].title, list[documentIndex].filename]));
						}
						return formatLocationListBlock(lines);
					case "field19":
						return String(value) === "true" || value === true ? "Activated" : "Not Activated";
					case "dateField1":
					case "datefield1":
						return formatLongDate(value);
					default:
						return String(value);
				}
			};

			var formatChecklistFieldValue = function (fieldKey, value, referenceData, stateSnapshot) {
				var parsedValue;
				var list;
				var lines;

				if (value === null || value === undefined || value === "") {
					return "empty";
				}

				switch (fieldKey) {
					case "field3":
						return referenceData.locations[String(value)] || ("Location " + value);
					case "field5":
						return referenceData.buttons[String(value)] || ("Button " + value);
					case "field6":
					case "field7":
						return getBooleanText(value);
					case "field8":
						parsedValue = parseNestedJson(value);
						list = parsedValue && parsedValue.questions ? parsedValue.questions : [];
						lines = [];
						for (var questionIndex = 0; questionIndex < list.length; questionIndex++) {
							lines.push(formatChecklistQuestion(list[questionIndex], referenceData));
						}
						return formatLocationListBlock(lines);
					case "field9":
					case "field11":
						return formatReminderTypes(value);
					case "field10":
						return formatReminderValues(stateSnapshot.field9, value, stateSnapshot.field16, stateSnapshot.field17);
					case "field12":
						return formatReminderValues(stateSnapshot.field11, value, stateSnapshot.field18, stateSnapshot.field19);
					case "field13":
						return formatReminderContacts(stateSnapshot.field9, value);
					case "field14":
						return String(value);
					case "field15":
						return String(value).split(',').join(', ');
					case "field16":
					case "field18":
						return String(value).split('::').map(function (entry) { return formatLongDate($.trim(entry)); }).join(', ');
					case "field17":
					case "field19":
						return String(value).split('::').join(', ');
					case "field20":
						return formatReminderContacts(stateSnapshot.field11, value);
					case "dateField1":
					case "datefield1":
						return formatLongDate(value);
					default:
						return String(value);
				}
			};

			var formatFieldValue = function (fieldKey, value, referenceData, stateSnapshot) {
				if (historyType === "location") {
					return formatLocationFieldValue(fieldKey, value, referenceData.personNames);
				}
				if (historyType === "checklist") {
					return formatChecklistFieldValue(fieldKey, value, referenceData, stateSnapshot || {});
				}
				if (historyType === "person") {
					return formatPersonFieldValue(fieldKey, value, referenceData);
				}
				if (value === null || value === undefined || value === "") return "empty";
				if (typeof value === "object") return JSON.stringify(value);
				if (value === true) return "true";
				if (value === false) return "false";
				return String(value);
			};

			var formatChangeHtml = function (text) {
				if (text && typeof text === 'object' && text.html) {
					return '<div class="sb-history-change-item" style="margin-bottom:8px; line-height:1.45;">' + text.content + '</div>';
				}
				return '<div class="sb-history-change-item" style="margin-bottom:8px; line-height:1.45; padding-left:14px; position:relative;">' +
					'<span style="position:absolute; left:0; top:0; color:#2f7d32; font-weight:bold;">•</span>' +
					escapeHtml(text) +
				'</div>';
			};

			var getItemData = function (item) {
				if (!item || !item.data || typeof item.data !== "object") {
					return {};
				}

				return item.data;
			};

			var buildChangeSummary = function (itemData, previousState, traceType, referenceData) {
				var ignoredKeys = { personName: true };
				var changedKeys = [];
				var itemKeys = Object.keys(itemData);
				for (var keyIndex = 0; keyIndex < itemKeys.length; keyIndex++) {
					if (!ignoredKeys[itemKeys[keyIndex]] && isAllowedHistoryField(itemKeys[keyIndex])) {
						changedKeys.push(itemKeys[keyIndex]);
					}
				}

				if (traceType === "Added") {
					return [getAddedHistoryLabel()];
				}

				if (traceType === "Deleted") {
					return "Deleted";
				}

				if (changedKeys.length === 0) {
					return traceType;
				}

				var summaryParts = [];
				for (var changedIndex = 0; changedIndex < changedKeys.length; changedIndex++) {
					var key = changedKeys[changedIndex];
					var oldValue = previousState ? previousState[key] : undefined;
					var newValue = itemData[key];
					var label = getFieldLabel(key);

					if (getComparableValue(oldValue) === getComparableValue(newValue)) {
						continue;
					} else if (historyType === "checklist" && key === "field8") {
						summaryParts.push(label + " updated");
						var questionCards = formatChecklistQuestionCards(newValue, referenceData);
						for (var cardIndex = 0; cardIndex < questionCards.length; cardIndex++) {
							summaryParts.push(questionCards[cardIndex]);
						}
					} else if (previousState && Object.prototype.hasOwnProperty.call(previousState, key)) {
						summaryParts.push(label + " updated from " + formatFieldValue(key, oldValue, referenceData, previousState) + " to " + formatFieldValue(key, newValue, referenceData, itemData));
					} else {
						summaryParts.push(label + " updated to " + formatFieldValue(key, newValue, referenceData, itemData));
					}
				}

				return summaryParts;
			};

			var cloneSimpleObject = function (source) {
				var clone = {};
				for (var sourceKey in source) {
					if (Object.prototype.hasOwnProperty.call(source, sourceKey)) {
						clone[sourceKey] = source[sourceKey];
					}
				}
				return clone;
			};

			var mergeSimpleObjects = function (target, source) {
				var merged = cloneSimpleObject(target);
				for (var sourceKey in source) {
					if (Object.prototype.hasOwnProperty.call(source, sourceKey)) {
						merged[sourceKey] = source[sourceKey];
					}
				}
				return merged;
			};

			var buildHistoryRows = function (historyItems, referenceData) {
				var chronologicalItems = historyItems.slice().reverse();
				var renderedRows = [];
				var currentState = {};

				for (var index = 0; index < chronologicalItems.length; index++) {
					var item = chronologicalItems[index];
					var itemData = getItemData(item);
					var previousState = cloneSimpleObject(currentState);
					var summary = buildChangeSummary(itemData, previousState, item.traceType, referenceData);

					currentState = mergeSimpleObjects(currentState, itemData);
					if (item.traceType === 'Updated' && (!$.isArray(summary) || summary.length === 0)) {
						continue;
					}
					renderedRows.push({ item: item, summary: summary });
				}

				return renderedRows.reverse();
			};

			var fetchGenDataNamesByIds = function (ids, fieldType, callback) {
				if (!ids || ids.length === 0) {
					callback([]);
					return;
				}

				if (typeof utils !== 'undefined' && utils && typeof utils.fetchGenDatas === 'function') {
					utils.fetchGenDatas({ ids: ids.join(',') }, function (response) {
						var filtered = [];
						var foundIds = {};
						for (var responseIndex = 0; responseIndex < response.length; responseIndex++) {
							if (!fieldType || response[responseIndex].field1 === fieldType) {
								filtered.push(response[responseIndex]);
								if (response[responseIndex].id !== undefined && response[responseIndex].id !== null) {
									foundIds[String(response[responseIndex].id)] = true;
								}
							}
						}

						var missingIds = [];
						for (var idIndex = 0; idIndex < ids.length; idIndex++) {
							var currentId = String(ids[idIndex]);
							if (!foundIds[currentId]) {
								missingIds.push(currentId);
							}
						}

						if (missingIds.length === 0) {
							callback(filtered);
							return;
						}

						var pending = missingIds.length;
						for (var missingIndex = 0; missingIndex < missingIds.length; missingIndex++) {
							(function (missingId) {
								utils.fetchGenDatas({ id: missingId }, function (singleResponse) {
									for (var singleIndex = 0; singleIndex < singleResponse.length; singleIndex++) {
										if ((!fieldType || singleResponse[singleIndex].field1 === fieldType) && !foundIds[String(singleResponse[singleIndex].id)]) {
											filtered.push(singleResponse[singleIndex]);
											foundIds[String(singleResponse[singleIndex].id)] = true;
										}
									}
									pending--;
									if (pending === 0) {
										callback(filtered);
									}
								});
							})(missingIds[missingIndex]);
						}
					});
					return;
				}

				callback([]);
			};

			var resolveHistoryReferenceData = function (historyItems, callback) {
				var referenceData = {
					personNames: {},
					locations: {},
					buttons: {},
					nfcTags: {},
					nfcTagCodes: {}
				};

				if (historyType !== "location" && historyType !== "checklist" && historyType !== "person") {
					callback(referenceData);
					return;
				}

				var personIdsMap = {};
				var locationIdsMap = {};
				var buttonIdsMap = {};
				var nfcIdsMap = {};
				for (var itemIndex = 0; itemIndex < historyItems.length; itemIndex++) {
					var itemData = getItemData(historyItems[itemIndex]);
					if (historyType === "location" && itemData.field10) {
						var splitIds = String(itemData.field10).split(',');
						for (var splitIndex = 0; splitIndex < splitIds.length; splitIndex++) {
							var personId = $.trim(splitIds[splitIndex]);
							if (personId) {
								personIdsMap[personId] = true;
							}
						}
					}
					if (historyType === "checklist") {
						if (itemData.field3) {
							locationIdsMap[String(itemData.field3)] = true;
						}
						if (itemData.field5) {
							buttonIdsMap[String(itemData.field5)] = true;
						}
						var questionData = parseNestedJson(itemData.field8);
						var questions = questionData && questionData.questions ? questionData.questions : [];
						for (var questionIndex = 0; questionIndex < questions.length; questionIndex++) {
							var nfcTagIds = questions[questionIndex].NFCTag ? String(questions[questionIndex].NFCTag).split(',') : [];
							for (var nfcIndex = 0; nfcIndex < nfcTagIds.length; nfcIndex++) {
								var nfcTagId = $.trim(nfcTagIds[nfcIndex]);
								if (nfcTagId) {
									nfcIdsMap[nfcTagId] = true;
								}
							}
						}
					}
					if (historyType === "person") {
						if (itemData.addInfo3) {
							var mainLocId = normalizeReferenceId(itemData.addInfo3);
							if (mainLocId) {
								locationIdsMap[mainLocId] = true;
							}
						}
						if (itemData.addInfo4) {
							var additionalLocationIds = String(itemData.addInfo4).split(',');
							for (var addLocIndex = 0; addLocIndex < additionalLocationIds.length; addLocIndex++) {
								var addLocId = normalizeReferenceId(additionalLocationIds[addLocIndex]);
								if (addLocId) {
									locationIdsMap[addLocId] = true;
								}
							}
						}
						if (itemData.addInfo6) {
							var creatorPersonId = normalizeReferenceId(itemData.addInfo6);
							if (creatorPersonId) {
								personIdsMap[creatorPersonId] = true;
							}
						}
						var accessData = parseNestedJson(itemData.addInfo7);
						if (accessData) {
							for (var accessLocationId in accessData) {
								if (!Object.prototype.hasOwnProperty.call(accessData, accessLocationId)) {
									continue;
								}
								var normalizedAccessLocationId = normalizeReferenceId(accessLocationId);
								if (normalizedAccessLocationId) {
									locationIdsMap[normalizedAccessLocationId] = true;
								}
								var accessButtonIds = accessData[accessLocationId] && accessData[accessLocationId].ids ? String(accessData[accessLocationId].ids).split(',') : [];
								for (var accessButtonIndex = 0; accessButtonIndex < accessButtonIds.length; accessButtonIndex++) {
									var accessButtonId = normalizeReferenceId(accessButtonIds[accessButtonIndex]);
									if (accessButtonId) {
										buttonIdsMap[accessButtonId] = true;
									}
								}
							}
						}
					}
				}

				var personIds = Object.keys(personIdsMap);
				var locationIds = Object.keys(locationIdsMap);
				var buttonIds = Object.keys(buttonIdsMap);
				var nfcIds = Object.keys(nfcIdsMap);
				var pending = 0;

				var onDone = function () {
					pending--;
					if (pending <= 0) {
						callback(referenceData);
					}
				};

				if ((historyType === "location" || historyType === "person") && personIds.length > 0) {
					pending++;
					var personPending = personIds.length;
					for (var idIndex = 0; idIndex < personIds.length; idIndex++) {
						(function (personId) {
							$.ajax({
								url: '/action/getPersons',
								method: 'get',
								data: { id: personId },
								dataType: 'json',
								success: function (person) {
									if (person && (person.firstName || person.lastName)) {
										referenceData.personNames[personId] = $.trim((person.firstName || '') + ' ' + (person.lastName || ''));
									}
								},
								complete: function () {
									personPending--;
									if (personPending === 0) {
										onDone();
									}
								}
							});
						})(personIds[idIndex]);
					}
				}

				if ((historyType === "checklist" || historyType === "person") && locationIds.length > 0) {
					pending++;
					fetchGenDataNamesByIds(locationIds, 'location', function (gendatas) {
						for (var gdIndex = 0; gdIndex < gendatas.length; gdIndex++) {
							if (gendatas[gdIndex] && gendatas[gdIndex].id) {
								referenceData.locations[String(gendatas[gdIndex].id)] = gendatas[gdIndex].field2 || ("Location " + gendatas[gdIndex].id);
							}
						}
						onDone();
					});
				}

				if ((historyType === "checklist" || historyType === "person") && buttonIds.length > 0) {
					pending++;
					fetchGenDataNamesByIds(buttonIds, 'button', function (gendatas) {
						for (var buttonIndex = 0; buttonIndex < gendatas.length; buttonIndex++) {
							if (gendatas[buttonIndex] && gendatas[buttonIndex].id) {
								referenceData.buttons[String(gendatas[buttonIndex].id)] = gendatas[buttonIndex].field2 || ("Button " + gendatas[buttonIndex].id);
							}
						}
						onDone();
					});
				}

				if (historyType === "checklist" && nfcIds.length > 0) {
					pending++;
					fetchGenDataNamesByIds(nfcIds, 'nfc', function (gendatas) {
						for (var nfcDataIndex = 0; nfcDataIndex < gendatas.length; nfcDataIndex++) {
							if (gendatas[nfcDataIndex] && gendatas[nfcDataIndex].id) {
								referenceData.nfcTags[String(gendatas[nfcDataIndex].id)] = gendatas[nfcDataIndex].field2 || ("NFC Tag " + gendatas[nfcDataIndex].id);
								referenceData.nfcTagCodes[String(gendatas[nfcDataIndex].id)] = gendatas[nfcDataIndex].field3 || "";
							}
						}
						onDone();
					});
				}

				if (pending === 0) {
					callback(referenceData);
					return;
				}
			};

			var buildSummaryHistoryRow = function (item) {
				var formattedTimestamp = formatHistoryTimestamp(item.item.createdAt);

				var summaryHtml = '';
				if ($.isArray(item.summary) && item.summary.length > 0) {
					for (var summaryIndex = 0; summaryIndex < item.summary.length; summaryIndex++) {
						summaryHtml += formatChangeHtml(item.summary[summaryIndex]);
					}
				} else {
					summaryHtml = formatChangeHtml(item.item.traceType || 'Updated');
				}

				return '<tr class="table__tr">' +
					'<td class="table__td h-0 p_p5rem_1rem" colspan="2">' +
						'<div class="sb-history-card" style="background:#f7faf7; border:1px solid #dbe8dc; border-left:4px solid #2f7d32; border-radius:10px; padding:14px 16px; margin-bottom:12px;">' +
							'<div class="sb-history-card__meta" style="display:flex; flex-wrap:wrap; gap:8px 16px; margin-bottom:10px;">' +
								'<div><span style="color:#5f6f63; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">' + escapeHtml(getSummaryHistoryLabel()) + '</span><div style="font-weight:700; color:#203224;">' + escapeHtml(modalData2) + '</div></div>' +
								'<div><span style="color:#5f6f63; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Updated By</span><div style="font-weight:600; color:#203224;">' + escapeHtml(item.item.createdByName || "") + '</div></div>' +
								'<div><span style="color:#5f6f63; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">When</span><div style="font-weight:600; color:#203224;">' + escapeHtml(formattedTimestamp) + '</div></div>' +
							'</div>' +
							'<div class="sb-history-card__changes">' +
								'<div style="color:#5f6f63; font-size:12px; text-transform:uppercase; letter-spacing:.04em; margin-bottom:8px;">What Changed</div>' +
								summaryHtml +
							'</div>' +
						'</div>' +
					'</td>' +
				'</tr>';
			};

			var fields = {
				type: historyType,
				recordId: modalData
			}

			if (parseInt(modalData) > 0) {
				$.ajax({
					url: "/action/fetchTraceChanges",
					method: "get",
					data: fields,
					dataType: 'json',
					success: function (response) {
						if (typeof response === 'string' && response.indexOf('error') != 0) {
							console.warn("no data available!");
						} else {
							var formattedResponse = Array.isArray(response) ? response : [response];
							var json = formattedResponse && formattedResponse != undefined && formattedResponse.length > 0 ? formattedResponse : undefined;

							var dataBody = $(".dataBody");
							dataBody.html("");
							if (json != undefined && json.length > 0) {
								var historyLabel = getSummaryHistoryLabel();
								$(".modal-title").text("#" + json[0].recordId + " " + historyLabel + " History");

								if (historyType === "location" || historyType === "person" || historyType === "checklist") {
									resolveHistoryReferenceData(json, function (referenceData) {
										var renderedRows = buildHistoryRows(json, referenceData);
										$("#history-modal .table__thead").html("");
										dataBody.html("");

										for (var i = 0; i < renderedRows.length; i++) {
											dataBody.append(buildSummaryHistoryRow(renderedRows[i]));
										}
									});
									return;
								}

								$("#history-modal .table__thead").html(
									'<tr class="table__tr table__tr_head">' +
										'<th class="table__th h-0 p_1rem_1rem_2rem sb-w10">Record</th>' +
										'<th class="table__th h-0 p_1rem_1rem_2rem">History</th>' +
									'</tr>'
								);
								for (var i = 0; i < json.length; i++) {
									var jsonInner = json[i].data ? json[i].data : undefined;
									var dataRow = '<tr class="table__tr">' +
										'<td class="table__td h-0 p_p5rem_1rem font-wb">#' + (i + 1) + " " + json[i].traceType + '</td>' +
										'<td class="h-0">' +
										'<table class="table">' +
										'<tbody class="table__tbody">';

									var dateFormat = new Intl.DateTimeFormat('en-US', {
										year: 'numeric',
										month: 'long',
										day: 'numeric',
										hour: 'numeric',
										minute: 'numeric',
										second: 'numeric',
										hour12: true,
									});
									var date = new Date(json[i].createdAt);
									var formattedDate = dateFormat.format(date);

									dataRow += '<tr class="table__tr">' +
										'<td class="table__td h-0 p_p5rem_1rem w_15Perc font-wb">Field</td>' +
										'<td class="table__td h-0 p_p5rem_1rem font-wb">Value</td>' +
										'</tr>';
									dataRow += '<tr class="table__tr">' +
										'<td class="table__td h-0 p_p5rem_1rem w_15Perc">' + modalData3 + ' Name</td>' +
										'<td class="table__td h-0 p_p5rem_1rem">' + modalData2 + '</td>' +
										'</tr>';

									dataRow += '<tr class="table__tr">' +
										'<td class="table__td h-0 p_p5rem_1rem w_15Perc">' + json[i].traceType + ' By/ At</td>' +
										'<td class="table__td h-0 p_p5rem_1rem">' + json[i].createdByName + '/ ' + formattedDate + '</td>' +
										'</tr>';

									dataRow += '<tr class="table__tr">';

									if (jsonInner) {
										var jsonInnerKeys = Object.keys(jsonInner);
										dataRow += '<td class="table__td h-0 p_p5rem_1rem w_15Perc">' + json[i].traceType + ' Data</td>';
										dataRow += '<td class="table__td h-0 p_p5rem_1rem">';
										dataRow += '<ul class="sb-m0 sb-pl13px">';
										for (var key in jsonInnerKeys) {
											var c1 = camelCaseToTitleCase(jsonInnerKeys[key]);
											var c2 = jsonInner[jsonInnerKeys[key]];

											dataRow += "<li class='sb-c485477'>" + (jsonInnerKeys[key] == "personName" ? json[i].traceType + " By " : c1) + ": " + c2 + "</li>";

										}
										dataRow += '</ul></td>';
									}
									dataRow += '</tr>';
									dataRow += '</tbody>' +
										'</table>' +
										'</td>' +
										'</tr>';
									dataBody.append(dataRow);
								}
							}
						}
					},
					error: () => {
						console.warn("no data available!");
					}
				});
			}
		} else if (modalFor == "history") {
			const modalData = $(e.currentTarget).attr("modal-data");
			// const json=modalData && modalData!=undefined && modalData.length>0?JSON.parse(modalData):undefined;

			var dataBody = $(".dataBody");
			dataBody.html("");
			var fields = {
				type: "incident",
				recordId: modalData,
				v2: true
			}

			if (parseInt(modalData) > 0) {
				$.ajax({
					url: "/action/fetchTraceChanges",
					method: "get",
					data: fields,
					dataType: 'json',
					success: function (response) {
						if (typeof response === 'string' && response.indexOf('error') != 0) {
							console.warn("no data available!");
						} else {
							var formattedResponse = Array.isArray(response) ? response : [response];
							const json = formattedResponse && formattedResponse != undefined && formattedResponse.length > 0 ? formattedResponse : undefined;

							if (json != undefined && json.length > 0) {
								$(".modal-title").text("#" + json[0].recordId + " Incident Report History");
								for (var i = 0; i < json.length; i++) {
									const jsonInner = json[i].data ? JSON.parse(json[i].data) : undefined;
									var dataRow = '<tr class="table__tr">' +
										'<td class="table__td h-0 p_p5rem_1rem font-wb">#' + (i + 1) + " " + json[i].traceType + '</td>' +
										'<td class="h-0">' +
										'<table class="table">' +
										'<tbody class="table__tbody">';

									if (jsonInner) {
										const jsonInnerKeys = Object.keys(jsonInner);

										dataRow += '<tr class="table__tr">' +
											'<td class="table__td h-0 p_p5rem_1rem w_15Perc font-wb">Field</td>' +
											'<td class="table__td h-0 p_p5rem_1rem font-wb">Value</td>' +
											'</tr>';

										for (const key in jsonInnerKeys) {
											var c1 = jsonInnerKeys[key];
											// var c2=c1=="createdBy" || c1=="updatedBy"?camelCaseToTitleCase(c1)+"/Date Time":camelCaseToTitleCase(c1);
											// var c3=c1=="createdBy" || c1=="updatedBy"?jsonInner[c1]+"/"+jsonInner[c1.replace("By","At")]:jsonInner[c1];

											// if(c1!="traceLogs" && c1!="locationId" && c1!="id" && c1!="updatedAt" && c1!="createdAt" && c1!="photos"){
											// 	dataRow+='<tr class="table__tr">'+
											// 				'<td class="table__td h-0 p_p5rem_1rem w_15Perc">'+c2+'</td>'+
											// 				'<td class="table__td h-0 p_p5rem_1rem">'+c3+'</td>'+
											// 			'</tr>';
											// }
											dataRow += '<tr class="table__tr">' +
												'<td class="table__td h-0 p_p5rem_1rem w_15Perc">' + c1 + '</td>' +
												'<td class="table__td h-0 p_p5rem_1rem">' + jsonInner[c1] + '</td>' +
												'</tr>';
										}
									}
									dataRow += '</tbody>' +
										'</table>' +
										'</td>' +
										'</tr>';
									dataBody.append(dataRow);
								}
							}
						}
					},
					error: () => {
						console.warn("no data available!");
					}
				});
			}

			// if(json!=undefined && json.length>0){
			// $(".modal-title").text("#"+json[0].recordId+" Incident Report History");
			// for(var i=0;i<json.length;i++){
			// 	const jsonInner=json[i].data?json[i].data:undefined;
			// 	var dataRow='<tr class="table__tr">'+
			// 	'<td class="table__td h-0 p_p5rem_1rem font-wb">#'+(i+1)+" "+json[i].traceType+'</td>'+
			// 	'<td class="h-0">'+
			// 		'<table class="table">'+
			// 			'<tbody class="table__tbody">';

			// 	if(jsonInner){
			// 		const jsonInnerKeys=Object.keys(jsonInner);

			// 		dataRow+='<tr class="table__tr">'+
			// 					'<td class="table__td h-0 p_p5rem_1rem w_15Perc font-wb">Field</td>'+
			// 					'<td class="table__td h-0 p_p5rem_1rem font-wb">Value</td>'+
			// 		'</tr>';

			// 		for (const key in jsonInnerKeys) {
			// 			var c1=jsonInnerKeys[key];
			// 			var c2=c1=="createdBy" || c1=="updatedBy"?camelCaseToTitleCase(c1)+"/Date Time":camelCaseToTitleCase(c1);
			// 			var c3=c1=="createdBy" || c1=="updatedBy"?jsonInner[c1]+"/"+jsonInner[c1.replace("By","At")]:jsonInner[c1];

			// 			if(c1!="traceLogs" && c1!="locationId" && c1!="id" && c1!="updatedAt" && c1!="createdAt" && c1!="involvedPersons" && c1!="photos"){
			// 				dataRow+='<tr class="table__tr">'+
			// 							'<td class="table__td h-0 p_p5rem_1rem w_15Perc">'+c2+'</td>'+
			// 							'<td class="table__td h-0 p_p5rem_1rem">'+c3+'</td>'+
			// 						'</tr>';
			// 			}else if(c1=="involvedPersons"){
			// 				dataRow+='<tr class="table__tr">'+
			// 							'<td class="table__td h-0 p_p5rem_1rem w_15Perc">'+c2+'</td>';

			// 				var personJson=c3!="" && c3!=undefined && c3!=null && !c3.indexOf("[")?JSON.parse(c3):undefined;
			// 				console.warn("personJson: "+personJson);	
			// 				dataRow+='<td class="table__td h-0 p_p5rem_1rem">';
			// 				if(personJson!=undefined && personJson.length>0){
			// 					dataRow+='<ul class="sb-m0 sb-pl13px">';
			// 					for (var k = 0; k < personJson.length; k++){
			// 						dataRow+="<li class='sb-c485477'>"+
			// 						(personJson[k].firstName!=undefined && personJson[k].firstName!="-"?personJson[k].firstName:"-")+
			// 						" "+
			// 						(personJson[k].lastName!=undefined && personJson[k].lastName!="-"?personJson[k].lastName:"-")+
			// 						"</li>";
			// 					}
			// 					dataRow+='</ul>';
			// 				}
			// 				dataRow+='</td>';
			// 				dataRow+='</tr>';
			// 			}
			// 		}
			// 	}
			// 	dataRow+='</tbody>'+
			// 			'</table>'+
			// 		'</td>'+
			// 	'</tr>';
			// 	dataBody.append(dataRow);
			// }
			// }
		} else {

		}
	}

	function loadMaps(markers, coords, loadMarker) {

		map = new google.maps.Map(document.getElementById('map'), {
			center: {
				lat: currentLoc.latitude == '' ? 56.1304 : currentLoc.latitude,
				lng: currentLoc.longitude == '' ? 106.3468 : currentLoc.longitude
			},
			zoom: 16
		});

		// if you have existing marker coordinates, show them
		new google.maps.Marker({
			position: new google.maps.LatLng(currentLoc.latitude == '' ? 56.1304 : currentLoc.latitude,
				currentLoc.longitude == '' ? 106.3468 : currentLoc.longitude),
			title: 'Marker',
			map: map,
			draggable: true
		});

		const drawingManager = new google.maps.drawing.DrawingManager({
			drawingMode: google.maps.drawing.OverlayType.POLYGON,
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT,
				drawingModes: ["polygon", "circle"],
			},
			polygonOptions: {
				fillColor: "#1E90FF",
				fillOpacity: 0.3,
				strokeWeight: 2,
				strokeColor: "#1E90FF",
				clickable: true,
				editable: true,
				zIndex: 1,
			},
			circleOptions: {
				fillColor: "#32CD32",
				fillOpacity: 0.3,
				strokeWeight: 2,
				strokeColor: "#32CD32",
				editable: true,
				clickable: true,
				zIndex: 1,
			},
		});


		drawingManager.setMap(map);

		getPolygonalCoordinates();

		// When drawing starts
		google.maps.event.addListener(drawingManager, 'drawingmode_changed', function () {
			const mode = drawingManager.getDrawingMode();
			if (mode === google.maps.drawing.OverlayType.POLYGON) {
				drawingInProgress = true;
			} else {
				drawingInProgress = false;
			}
		});



		google.maps.event.addListener(drawingManager, "overlaycomplete", function (event) {

			activePolygon = event.overlay; // the finished polygon
			drawingInProgress = false;

			const id = "internal_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
			const type = event.type;
			const defaultName = type === "polygon" ? `Street ${nextNum}` : `Street ${nextNum}`;
			nextNum++;

			pendingEntry = { id, overlay: event.overlay, type, name: defaultName, locationName: $('#geofence-location').val() };

			showNameModal(defaultName, (finalName, confirmed) => {
				if (!confirmed) {
					event.overlay.setMap(null);
					pendingEntry = null;
					return;
				}
				pendingEntry.name = finalName.trim() || defaultName;
				overlays.push(pendingEntry);
				addDropdownOption(pendingEntry);
				printAllGeofences();

				if (type === "polygon") {
					const path = event.overlay.getPath();
					const coords = [];
					path.forEach(v => coords.push({ lat: v.lat(), lng: v.lng() }));
					console.log(`${pendingEntry.name} coords:`, coords);

				} else if (type === "circle") {
					const center = event.overlay.getCenter();
					const radius = event.overlay.getRadius();
					console.log(`${pendingEntry.name} center:`, center.toJSON(), "Radius:", radius);

				}

				const currentEntry = pendingEntry;
				event.overlay.addListener("click", function () {
					removeGeofence(currentEntry.id);
				});

				pendingEntry = null;
			});

		});

		document.addEventListener('keydown', function (e) {
			if (e.key === "Escape") {
				if (activePolygon) {
					activePolygon.setMap(null);
					activePolygon = null;
				}

				if (drawingInProgress) {
					// Cancel drawing mode to remove in-progress polygon
					drawingManager.setDrawingMode(null);
					drawingInProgress = false;
				}
			}
		});

		// Modal buttons
		document.getElementById("cancel-name").addEventListener("click", () => {
			hideNameModal(false);
		});
		document.getElementById("save-name").addEventListener("click", () => {
			const inputEl = document.getElementById("geofence-name-input");
			hideNameModal(true, inputEl.value);
		});
		document.getElementById("geofence-name-input").addEventListener("keydown", (e) => {
			if (e.key === "Enter") {
				e.preventDefault();
				document.getElementById("save-name").click();
			}
		});

		$(document).on("change", "#geofence-select", function () {
			const sel = this.value;
			if (!sel) return;
			const entry = overlays.find(o => o.id === sel);
			if (!entry) return;
			focusOnGeofence(entry);
		});
	}

	function clearAllGeofences() {
		overlays.forEach(entry => entry.overlay.setMap(null));
		overlays.length = 0;
		const select = document.getElementById("geofence-select");
		select.innerHTML = '<option value="">Select</option>';
		select.value = "";
	}


	function clearAllLocations() {
		const select = document.getElementById("location-select");
		select.innerHTML = '<option value="">Select</option>';
		select.value = "";
	}

	function showNameModal(initial, callback) {
		const backdrop = document.getElementById("name-modal-backdrop");
		const input = document.getElementById("geofence-name-input");
		input.value = initial || "";
		backdrop.style.display = "flex";
		input.select();
		input.focus();
		backdrop._cb = callback;
	}

	function hideNameModal(confirmed, value = "") {
		const backdrop = document.getElementById("name-modal-backdrop");
		backdrop.style.display = "none";
		const cb = backdrop._cb;
		if (typeof cb === "function") {
			cb(value, confirmed);
		}
		backdrop._cb = null;
	}

	function CenterControl(buttonTitle, hint, index, padding = "1.3rem 3.5rem", margin = "0 0 2rem 0") {
		// Create the control container
		padding = "1.3rem 3.5rem";
		const controlUI = document.createElement('div');

		const style = {
			backgroundColor: "#024a9b",
			color: "#fff",
			border: "1px solid transparent",
			borderRadius: "5px",
			minWidth: "15rem",
			padding: padding,
			margin: margin,
			fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
			fontSize: "1.6rem",
			fontWeight: "700",
			lineHeight: "1.25",
			whiteSpace: "nowrap",
			textAlign: "center",
			cursor: "pointer",
			display: "inline-block",
			boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.15)",
			transition: "background-color .3s ease, color .3s ease",
		};

		Object.assign(controlUI.style, style);

		controlUI.title = hint;
		controlUI.innerHTML = buttonTitle;
		controlUI.index = index;

		// Optional hover effect (like Bootstrap buttons)
		controlUI.addEventListener("mouseenter", () => {
			controlUI.style.backgroundColor = "#0a58ca"; // bootstrap hover color
		});
		controlUI.addEventListener("mouseleave", () => {
			controlUI.style.backgroundColor = "#024a9b";
		});

		return controlUI;
	}

	function focusOnGeofence(entry) {
		if (entry.type === "polygon") {
			$('#geofence-location').val(entry.locationName);
			const path = entry.overlay.getPath();
			const bounds = new google.maps.LatLngBounds();
			path.forEach(pt => bounds.extend(pt));
			map.fitBounds(bounds);
		} else if (entry.type === "circle") {
			$('#geofence-location').val(entry.locationName);
			const center = entry.overlay.getCenter();
			const radius = entry.overlay.getRadius();
			const bounds = new google.maps.LatLngBounds();
			bounds.extend(google.maps.geometry.spherical.computeOffset(center, radius, 0));
			bounds.extend(google.maps.geometry.spherical.computeOffset(center, radius, 180));
			bounds.extend(google.maps.geometry.spherical.computeOffset(center, radius, 90));
			bounds.extend(google.maps.geometry.spherical.computeOffset(center, radius, 270));
			map.fitBounds(bounds);
		}
	}

	function printAllGeofences() {
		console.log("Current Geofences:");
		overlays.forEach(({ id, name, type, overlay }, index) => {
			if (type === "polygon") {
				const path = overlay.getPath();
				const coords = [];
				path.forEach((point) => coords.push(`${point.lat().toFixed(6)},${point.lng().toFixed(6)}`));
				console.log(`${index + 1}. Name: ${name}, Type: Polygon, Coordinates:`, coords);
			} else if (type === "circle") {
				const center = overlay.getCenter();
				const radius = overlay.getRadius();
				console.log(`${index + 1}. Name: ${name}, Type: Circle, Center: ${center.toUrlValue()}, Radius: ${radius}`);
			}
		});
	}

	function removeGeofence(id) {
		const idx = overlays.findIndex(o => o.id === id);
		if (idx === -1) return;
		const entry = overlays[idx];
		entry.overlay.setMap(null);
		overlays.splice(idx, 1);
		const select = document.getElementById("geofence-select");
		const option = select.querySelector(`option[value="${id}"]`);
		if (option) option.remove();
		if (select.value === id) select.value = "";
		console.log(`Removed geofence ${entry.name}`);
	}

	function loadLocation(id, markers, coords, dontWork) {
		utils.fetchGenDatas({ id, json: true }, gds => {
			if (typeof gds == 'object') {
				var addr = resolveStr(gds[0].field4, "") + resolveStr(gds[0].field5, " ") + resolveStr(gds[0].field6, ", ") +
					resolveStr(gds[0].field7, ", ") + resolveStr(gds[0].field9, ", ");
				loadCoordinates(addr, resolveStr(gds[0].field4, ""), markers, coords, 3);
			}
		});
	}

	function resolveStr(str, chr) {
		return str !== undefined && str != null && str != "" ? chr + str.trim() : "";
	}

	function addButtonGeofence(text) {
		var div2 = new CenterControl((text) + " Geofence"
			, 'text building name and geofence', 2, '10px 5px 10px 5px', '0 0 18px 10px');
		div2.id = "updateBtn";
		div2.addEventListener('click', function () {
			addPolygonalCoordinates();
			$(".show-modal").toggleClass("show-modal");
		});

		// map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(div1);
		map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(div2);

	}

	function getPolygonalCoordinates() {


		$.ajax({
			url: `${url}/public/get-polygonal-coordinates?personId=${$('#geofencePersonId').val()}&userId=${params.get('personId')}`,
			complete: (res) => {
				clearAllGeofences();
				var response = res.responseText;

				if (response) {
					let parsed = JSON.parse(response); // parse the full JSON string
					polygonalCoordinates = response;

					const button = document.querySelector('button[modal-id="geofence-modal"]');
					if (button && parsed.geofences && parsed.geofences.length > 0) {

						addButtonGeofence("Update")

						button.innerHTML = `
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="23" height="23"><path d="M22.3,0.7c-0.9-0.9-2.5-0.9-3.4,0l0,0l-0.8,0.8c-0.7-0.3-1.5-0.1-2.1,0.4L1.5,16.4c-0.1,0.1-0.2,0.2-0.2,0.4L0,22c-0.1,0.4,0.2,0.9,0.6,1c0.1,0,0.1,0,0.2,0H1l5.2-1.2c0.1,0,0.3-0.1,0.4-0.2L21.1,7.1c0.6-0.5,0.7-1.4,0.4-2.1l0.8-0.8C23.3,3.2,23.3,1.7,22.3,0.7L22.3,0.7L22.3,0.7z M21.2,1.8c0.3,0.3,0.3,0.8,0,1.1c0,0,0,0,0,0l0,0l-0.7,0.7l-1.1-1.1L20,1.8C20.3,1.5,20.9,1.5,21.2,1.8z M10.7,12.3c0.3,0.3,0.8,0.3,1.1,0l4.6-4.6l0.8,0.8L6,19.8L3.2,17L14.5,5.7l0.8,0.8l-4.6,4.6C10.4,11.4,10.4,11.9,10.7,12.3L10.7,12.3z M2.5,18.6l1.9,1.9l-2.5,0.6L2.5,18.6z M19.9,5.9l-1.4,1.4l-2.9-2.8l1.4-1.4c0.1-0.1,0.3-0.1,0.4,0L20,5.5C20.1,5.6,20.1,5.8,19.9,5.9L19.9,5.9z"></path></svg> Add-Edit`;
					} else if (button) {

						addButtonGeofence("Add")

						button.innerHTML = `
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.3 70.3" width="70.3" height="70.3"><path d="M35.1,70.3C15.7,70.3,0,54.5,0,35.1C0,15.7,15.7,0,35.1,0c19.4,0,35.1,15.7,35.1,35.1c0,0,0,0,0,0     C70.2,54.5,54.5,70.2,35.1,70.3z M35.1,4.8C18.4,4.8,4.8,18.4,4.8,35.1s13.6,30.4,30.4,30.4c16.8,0,30.4-13.6,30.4-30.4     C65.5,18.4,51.9,4.8,35.1,4.8z M50.2,33.4h-13v-13c0-1.2-0.9-2.1-2.1-2.1c0,0,0,0,0,0l0,0c-1.2,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0v13     h-13c-1.2,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0l0,0c0,1.2,0.9,2.1,2.1,2.1c0,0,0,0,0,0h13v13c0,1.2,0.9,2.1,2.1,2.1c0,0,0,0,0,0l0,0     c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0v-13h13c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0l0,0C52.4,34.4,51.4,33.4,50.2,33.4     C50.3,33.4,50.2,33.4,50.2,33.4z"></path></svg> Add new`;
					}

					if (button && parsed.geofences && parsed.geofences.length > 0) {

						// Iterate over all location IDs
						let geofences = parsed.geofences;

						if (!Array.isArray(geofences)) return;

						geofences.forEach(gf => {
							if (!gf.name) return;
							let entry;

							if (gf.type === "circle" && gf.center && typeof gf.radius === "number") {
								const [lat, lng] = gf.center.split(",").map(Number);
								const center = new google.maps.LatLng(lat, lng);
								const circle = new google.maps.Circle({
									center,
									radius: gf.radius,
									fillColor: "#32CD32",
									fillOpacity: 0.3,
									strokeWeight: 2,
									strokeColor: "#32CD32",
									editable: true,
									clickable: true,
									zIndex: 1,
									map: map,
								});
								const id = "loaded_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
								entry = { id, overlay: circle, type: "circle", name: gf.name, locationName: gf.locationName };
								overlays.push(entry);
								addDropdownOption(entry);
								circle.addListener("click", () => removeGeofence(entry.id));
								nextNum++;
							}
							else if (Array.isArray(gf.coords)) {
								const path = gf.coords.map(c => {
									const [lat, lng] = c.split(",").map(Number);
									return new google.maps.LatLng(lat, lng);
								});
								const polygon = new google.maps.Polygon({
									paths: path,
									fillColor: "#1E90FF",
									fillOpacity: 0.3,
									strokeWeight: 2,
									strokeColor: "#1E90FF",
									clickable: true,
									editable: true,
									zIndex: 1,
									map: map,
								});
								const id = "loaded_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
								entry = { id, overlay: polygon, type: "polygon", name: gf.name, locationName: gf.locationName };
								overlays.push(entry);
								addDropdownOption(entry);
								polygon.addListener("click", () => removeGeofence(entry.id));
								nextNum++;
							}
						});

					}
				} else {
					addButtonGeofence("Add");
				}
			},
			error: (res) => {
				console.log(res);
			}
		});
	}


	function buildExportObject() {
		const geofences = overlays.map(({ name, type, overlay, locationName }) => {
			if (type === "polygon") {
				const path = overlay.getPath();
				const coords = [];
				path.forEach(p => coords.push(`${p.lat().toFixed(6)},${p.lng().toFixed(6)}`));
				return { name, coords, locationName };
			} else if (type === "circle") {
				const center = overlay.getCenter();
				const radius = overlay.getRadius();
				return {
					name,
					type: "circle",
					center: `${center.lat().toFixed(6)},${center.lng().toFixed(6)}`,
					radius,
					locationName
				};
			}
		}).filter(Boolean);
		return { locationPlaceholder: { geofences } };
	}

	function addPolygonalCoordinates() {

		// let polygonCoordinatesJson =
		// 	polygonalCoordinates === undefined || polygonalCoordinates === ""
		// 		? {}
		// 		: JSON.parse(polygonalCoordinates);

		// const locationId = $('#add-user-form-location-select').find(":selected").val().split(":")[0];
		const geofencesArray = buildExportObject().locationPlaceholder.geofences;

		// // If no entry for this locationId, create one
		// if (!polygonCoordinatesJson[locationId]) {
		// 	polygonCoordinatesJson[locationId] = {};
		// }

		// Set or replace the geofences array
		let geofences = { geofences: geofencesArray };
		const userId = params.get('personId');

		// Send as JSON in body (recommended)
		$.ajax({
			url: `${url}/public/add-polygonal-coordinates`,
			method: "POST",
			contentType: "application/json",
			data: JSON.stringify({
				polygonCoordinates: geofences,
				personId: personId,
				userId: userId,
			}),
			success: (res) => {
				console.log("Polygon coordinates saved!", res);
				getPolygonalCoordinates();
			},
			error: (err) => {
				console.error("Error saving coordinates", err);
			}
		});
	}


	function addDropdownOption(entry) {
		const select = document.getElementById("geofence-select");
		const opt = document.createElement("option");
		opt.value = entry.id;
		opt.textContent = entry.name;
		select.appendChild(opt);
		select.value = entry.id;
		// focusOnGeofence(entry);
	}

	function addDropdownOptionForLocation(entry) {
		const select = document.getElementById("location-select");
		const opt = document.createElement("option");
		opt.value = entry.id;
		opt.textContent = entry.name;
		select.appendChild(opt);
		select.value = entry.id;
	}

	function loadCoordinates(address, fPart, markers, coords, retry, dontWork) {
		// Replace YOUR_API_KEY with your actual API key
		var apiKey = 'AIzaSyCGx5fRfEfS8X2QqfeMbM1qzxntXCwa6FI';
		// Encode the address so it can be used in the URL
		var encodedAddress = encodeURIComponent(address);
		// Build the URL for the Geocoding API request
		var apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodedAddress + '&key=' + apiKey;
		// Send the API request
		$.ajax({
			url: apiUrl,
			complete: (res) => {
				// var json=JSON.parse(res);
				if (res) {

					var geo = null;
					var results = res.responseJSON.results;
					for (var i = 0; i < results.length; i++) {
						if (String(results[i].formatted_address).toLocaleLowerCase().includes(fPart.toLowerCase())) {
							geo = results[i].geometry.location;
							$('#geofence-location').val(results[i].formatted_address);
						}
					}

					if (geo == null) {
						geo = results[0].geometry.location;
						$('#geofence-location').val(results[0].formatted_address);
					}
					currentLoc = { latitude: geo.lat, longitude: geo.lng };
					if (!dontWork)
						loadMaps(markers, coords, true);
				}
			},
			error: (res) => {
				if (retry > 0) {
					console.warn("getCoordinates error retrying..." + (retry));
					retry--;
					loadCoordinates(address, fPart, markers, coords, retry, false);
				} else alert("Address \"" + address + "\" did not resolved!");
				// googleCoordinates=null;
			}
		});
	}

	$(window).ready(function () {
		init();
	});
})(jQuery);